<script setup lang="ts">
import { CreateButton } from '@/components/Buttons'
import { ref } from 'vue'
import BaseDialog from '../../../../components/Modals/Dialog/BaseDialog.vue'
import TypographyItem from '../../../../components/Typography/TypographyItem.vue'
import store from '../../../../store'
import { EEventActions } from '../../../../store/eventStore/EventStoreTypes'
import { EStoreModules } from '../../../../store/storeType'

type Props = {
    eventId: number
    loading?: boolean
}
const props = defineProps<Props>()
const emit = defineEmits<{ (e: 'refresh'): void }>()

const open = ref(false)
const handleDialogOpen = (value: boolean) => (open.value = value)

const syncCheckpoints = () =>
    store
        .dispatch(`${EStoreModules.EVENT}/${EEventActions.SYNC_CHECKPOINTS}`, props.eventId)
        .then(() => emit('refresh'))
        .finally(() => (open.value = false))
</script>

<template>
    <CreateButton
        :loading="loading"
        :label="$t('event.button.syncCheckpoint')"
        @click="handleDialogOpen(true)" />
    <BaseDialog
        :open="open"
        :title="$t('event.detail.checkpoints.syncCheckpointTitle')"
        :loading="!!store.state.event.isLoading"
        @confirm="syncCheckpoints"
        @close="handleDialogOpen(false)">
        <template #content>
            <TypographyItem :label="$t('event.detail.checkpoints.syncCheckpoints')" />
        </template>
    </BaseDialog>
</template>
